import Divider from "../components/divider.js";

import img1 from "../assets/img/_1058371.webp";
import img2 from "../assets/img/Seminarhaus_Hof.webp";
import img3 from "../assets/img/Tanzraum.webp";
import img4 from "../assets/img/Seminarhaus.webp";
import sundaydance from "../assets/img/_1208900.webp";
import herbstbild from "../assets/img/Herbstbild_Munich.webp";

function Gruppenangebote() {
  return <div className="main-wrapper">
    
    

    <span id="sundaymoves"/>

    <h1>Gruppenangebote</h1>

    <h2>Happy & Healthy Sunday&nbsp;Moves</h2>

    <div className="center">
      <img className="size50" src={sundaydance}></img>
    </div>

    <h3>
      Kreativer Tanz als Heilsame Bewegung
    </h3>

    <p>
      In einer Welt voller äußerer Reize, Anforderungen und häufigem Zeitdruck nehmen wir uns bewusst die Zeit und den Raum zum Durchatmen, Innehalten und Ankommen – zum Spüren, zum Erfahren und für gegenseitige Unterstützung. Wir tanzen und bewegen uns frei, freudvolle Bewegung hilft, Stress abzubauen und Anspannungen loszulassen.<br />
      Es gibt bei jedem Termin ein kleines Thema, Vorschläge und Impulse von mir und ausreichend Zeit für Austausch. 
    </p>

    <h3>
      Termine
    </h3>

    <p>
      Schnupperkurse (Spende für den Raum möglich):<br />
      <span className="italic grey">
      25.10.2026 (Thema: Mir Langsamkeit erlauben – im Herbst ankommen)<br />
      27.12.2026
      </span>
    </p>

    <p>
      Termine 2027 (35 €):<br />
      <span className="italic grey">
      31.01.2027<br />
      28.02.2027<br />
      21.03.2027
      </span>
    </p>

    <h3>
      Zeit & Ort
    </h3>

    <p>
      15-18 Uhr (Ankommen ab 14:45 Uhr)<br />
      Theresienstraße 148, 80333 München
    </p>

    <h3>
      Info & Anmeldung
    </h3>

    <p>
      Einzeln buchbar, Anmeldung per Mail bitte bis jeweils Mittag des Vortages an <a href="mailto:info@solveig-bissinger.de">info@solveig-bissinger.de</a>.
    </p>

    <div className="center">
      <img className="size50" src={herbstbild}></img>
    </div>

    <span id="jahreskurs"/>

    <Divider />

    <h2>Jahreskurs</h2>
    
    <p>
      2026/2027 biete ich wieder einen Jahreskurs „Kreativer Tanz & Heilsame Bewegung“ an, vier Wochenenden Lebendigkeit & Kreativität entdecken, sich wieder besser spüren, bei sich liebevoll ankommen. Freie Bewegung, ohne Vorkenntnisse, ohne vorgegebene Schritte, ohne Leistungsdruck, in einer kleinen Gruppe, in einem sicheren Raum. Erholung für die Sinne, Entspannung für das Nervensystem, Ressourcen erkennen und stärken, Resilienz aufbauen.
    </p>

    {/* <div className="center">
      <img className="size50" src={img1}></img>
    </div> */}
    {/* Sonnenblume */}

    <h3>
      Zeit für mich – für innere Ruhe & Kraft
    </h3>

    <p className="strong font-color">
      Kreativer Tanz & Heilsame Bewegung Termine 2026/2027
    </p>

    <p className="italic grey">
      10.-12. April 2026 — Frühlingswochenende<br/>
      19.-21. Juni 2026 — Sommerwochenende<br/>
      2.-4. Oktober 2026 — Herbstwochenende<br/>
      15.-17. Januar 2027 — Winterwochenende
    </p>

    <p className="strong font-color">
      Eine bewusste Auszeit.<br/>
      Das Leben wieder spüren.<br/>
      In Verbindung sein. Mit mir, den Anderen, und der Natur.<br/>
      Lauschen auf das, was mein Körper mir sagt. Spüren, was mir genau jetzt guttut.
    </p>

    <p>
      Ein ganzes Wochenende freier, kreativer Tanz und nährende, heilsame Bewegung unterstützen dich und geben dir <strong className="strong font-color">Impulse für den Alltag</strong> mit Elementen aus der Holistischen Tanztherapie, Continuum und sensitivem Yoga. Es sind <strong className="strong font-color">keine Vorkenntnisse</strong> notwendig. Du bist willkommen, so wie du bist. Es geht nicht darum, bestimmte Schrittfolgen oder eine Methode zu erlernen, sondern dem eigenen Bewegungsfluss zu folgen. Selbsterfahrung und <strong className="strong font-color">Stärkung der Intuition</strong> stehen im Mittelpunkt.
    </p>

    <p>
      Wir haben ein einfaches, ruhiges Seminarhaus auf dem Land ganz für uns, mit einem <strong className="strong font-color">wunderbaren hellen Tanzraum</strong>, schönem Holzboden und <strong className="strong font-color">Fußbodenheizung</strong>. Es befindet sich an einem kraftvollen Ort im Nördlinger Ries am Kraterrand, eine <strong className="strong font-color">einzigartige Landschaft</strong>. Es gibt leckeres vegetarisches Essen, frisch zubereitet, vorwiegend bio & regional.
    </p>

    <div className="center">
      <img className="size50" src={img2}></img>
    </div>
    
    <h3>
      Ablauf
    </h3>

    <p>
      Freitag: ab 15:30 Ankommen, Zimmer beziehen, Start 18 Uhr<br/>
      Samstag: 2 Kurseinheiten (davon 1 Einheit draußen, je nach Wetter)<br/>
      Sonntag: 1 Kurseinheit, Mittagessen, Abschlusskreis (Ende ca. 15:30)
    </p>

    <h3>
      Kosten & Bedingungen
    </h3>

    <p>
      <div className="bulletpoint"/>Wochenende inkl. Übernachtung & Verpflegung: 395 Euro<br/>
      <div className="bulletpoint"/>Jahreskurs: 4 aufeinanderfolgende Wochenenden: insg. 1400 Euro (Verrechnung beim 4. Wochenende)<br/>
      <div className="bulletpoint"/>Anzahlung bei Anmeldung: 150 Euro (entspricht den Stornogebühren)<br/>
      <div className="bulletpoint"/>Einzelzimmerzuschlag: 60 Euro je Wochenende
    </p>

    <h3>
      Info & Anmeldung
    </h3>

    <p>
      Telefon: <a href="tel:+49 89 43630078">+49 89 43630078</a><br/>
      E-Mail: <a href="mailto:info@solveig-bissinger.de">info@solveig-bissinger.de</a>
    </p>

    {/* <a href="../files/2026_SommerTanzWochenende.pdf" target="_blank" rel="noopener noreferrer">
      Flyer ansehen
    </a> */}

    <img className="size53 left" src={img3}></img>
    <img className="size53 right" src={img4}></img>


  </div>;
}
export default Gruppenangebote;